import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { closeDrawer } from "../../actions/shared/actions_shared_1";
import {
    getEntrepriseInfos,
    getEntrepriseSalaries,
    getPerspectives
} from './../../actions/entreprise/actions_entreprise_1';
import NoMatch from "./../shared/pages/NoMatch";
import CustomAppBar from "./../shared/utils/CustomAppBar";
import PrivateRoute from './../shared/utils/PrivateRoute';
import AjouterFormations from './bodies/entreprise/AjouterFormations';
import BibliothequeDesCompetences from "./bodies/entreprise/BibliothequeDesCompetences";
import EditionGenerale from "./bodies/entreprise/EditionGenerale";
import PostesDisponibles from "./bodies/entreprise/PostesDisponibles";
import Synthese from './bodies/entreprise/Synthese';
import ConsulterEntretien from "./bodies/entretiens/ConsulterEntretien";
import EntretienWrapper from "./bodies/entretiens/passer_entretien/EntretienWrapper";
import PasserEntretien from './bodies/entretiens/passer_entretien/_index';
import IndexBody from './bodies/IndexBody';
import AjouterDesSalaries from "./bodies/salaries/AjouterDesSalaries";
import ConvoquerUnSalarie from "./bodies/salaries/ConvoquerUnSalarie";
import EtatDesLieux from "./bodies/salaries/EtatDesLieux";
import ExprerienceProSalarie from "./bodies/salaries/ExprerienceProSalarie";
import ModifierUnSalarie from "./bodies/salaries/ModifierUnSalarie";
import EntrepriseDrawer from "./EntrepriseDrawer";


class EntrepriseIndex extends Component {

    componentDidMount() {
        this.props.dispatch(getEntrepriseInfos());
        this.props.dispatch(getPerspectives());
        this.props.dispatch(getEntrepriseSalaries());
    }

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            this.props.dispatch(closeDrawer());
        }
    }

    render() {
        return (
            <div className="entreprise-container">
                <EntrepriseDrawer history={this.props.history} />
                <CustomAppBar
                    titlePath='/entreprise'
                    history={this.props.history}
                    title={this.props.entrepriseName}
                    dispatch={this.props.dispatch} />

                <Switch>
                    <PrivateRoute exact path="/entreprise" component={IndexBody} />
                    <PrivateRoute path="/entreprise/edition_generale" component={EditionGenerale} />
                    <PrivateRoute path="/entreprise/synthese" component={Synthese} />
                    <PrivateRoute path="/entreprise/postes_disponibles" component={PostesDisponibles} />
                    <PrivateRoute path="/entreprise/ajouter_des_salaries" component={AjouterDesSalaries} />
                    <PrivateRoute path="/entreprise/modifier_un_salarie/:id_salarie?" component={ModifierUnSalarie} />
                    <PrivateRoute path="/entreprise/experiences_pro_salarie/:id_salarie?"
                        component={ExprerienceProSalarie} />
                    <PrivateRoute path="/entreprise/formations/:id_salarie?"
                        component={AjouterFormations} />
                    <PrivateRoute path="/entreprise/convoquer_un_salarie/:id_salarie?" component={ConvoquerUnSalarie} />
                    <PrivateRoute path="/entreprise/etat_des_lieux" component={EtatDesLieux} />
                    <PrivateRoute path="/entreprise/consulter_entretien" component={ConsulterEntretien} />
                    <PrivateRoute exact path="/entreprise/passer_entretien" component={PasserEntretien} />
                    <PrivateRoute exact path="/entreprise/bibliotheque-des-competences"
                        component={BibliothequeDesCompetences} />
                    <PrivateRoute path="/entreprise/passer_entretien/:id_entretien/:step_index?"
                        component={EntretienWrapper} />
                    <Route component={NoMatch} />
                </Switch>
            </div>
        );
    }

}

function mapStateToProps(store) {
    return { entrepriseName: store.entreprise.entreprise_infos.nom }
}

export default connect(mapStateToProps)(EntrepriseIndex);


// WEBPACK FOOTER //
// ./src/components/entreprise/index.js